import {
  ScheduledNotificationResponse,
  NotificationStatus,
  getNotificationStatus,
} from "../../types/api/notifications";

/* 
Нельзя разрешить одновременное выделение 
уведомлений с разным статусом
*/
export class CheckNotificationStatus {
  private notifications: ScheduledNotificationResponse[];

  constructor(data: ScheduledNotificationResponse[]) {
    this.notifications = data;
  }

  isEqualStatus = (id: string, status: NotificationStatus): boolean => {
    const notification = this.notifications.find((u) => u.id === id);
    if (notification) return getNotificationStatus(notification) === status;
    return true;
  };

  allEqualStatus = (ids: string[], status: NotificationStatus) => {
    return ids.every((id) => {
      const notification = this.notifications.find((u) => u.id === id);
      if (notification) return getNotificationStatus(notification) === status;
      return true;
    });
  };

  isAllNotificationsStatusEqual = (): boolean => {
    if (this.notifications.length === 0 || this.notifications.length === 1) {
      return true;
    }
    const firstNotification = this.notifications[0];
    const firstNotificationStatus = getNotificationStatus(firstNotification);

    return this.notifications.every(
      (notification) =>
        getNotificationStatus(notification) === firstNotificationStatus
    );
  };
}
